import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import SearchPop from "./SearchPop";
import Login from "./Login";
import ShoppingPop from "./ShoppingPop";
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from "../../store/actions";
import { isDesktop } from "react-device-detect";

const Header = () => {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings);
  const lang = useSelector((state) => state.lang);
  const categories = useSelector((state) => state.categories);
  const currencies = useSelector((state) => state.currencies);
  const currency = useSelector((state) => state.currency);
  const user = useSelector((state) => state.user);

  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const openLogin = () => setIsLoginOpen(true);
  const closeLogin = () => setIsLoginOpen(false);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggleDropdown = () => setIsOpen(!isOpen);
  const setLanguage = (val) => {
    dispatch({ type: actionTypes.SET_LANGUAGE, payload: val });
  };
  const setCurrency = (val) => {
    dispatch({ type: actionTypes.SET_CURRENCY, payload: val });
    setIsOpen(false);
  };
  // const setCategories = (val) => {
  //   dispatch({ type: actionTypes.SET_CATEGORIES, payload: val });
  // };
  // const fetchCategories = async () => {
  //   const res = await fetch("/api/categories");
  //   return res.json();
  // };

  // return useQuery(["categories"], fetchCategories, {
  //   staleTime: 5 * 60 * 1000, // 5 minutes
  //   onSuccess: (data) => {
  //     setCategories(data);
  //     localStorage.setItem("categories", JSON.stringify(data));
  //   },
  //   initialData: () => {
  //     const cached = localStorage.getItem("categories");
  //     return cached ? JSON.parse(cached) : undefined;
  //   },
  // });
  return (
    <>
      <div className="tf-top-bar line">
        <div className="px_15 lg-px_40">
          <div className="tf-top-bar_wrap grid-3 gap-30 align-items-center">
            <ul className="tf-top-bar_item tf-social-icon d-flex gap-10">
              {settings.facebook ? (
                <li>
                  <Link
                    to={settings.facebook}
                    target="_blank"
                    className="box-icon w_28 round social-facebook bg_line"
                  >
                    <i className="icon fs-14 icon-fb"></i>
                  </Link>
                </li>
              ) : (
                ""
              )}
              {settings.twiter ? (
                <li>
                  <Link
                    to={settings.twiter}
                    target="_blank"
                    className="box-icon w_28 round social-twiter bg_line"
                  >
                    <i className="icon fs-12 icon-twiter"></i>
                  </Link>
                </li>
              ) : (
                ""
              )}
              {settings.instagram ? (
                <li>
                  <Link
                    to={settings.instagram}
                    target="_blank"
                    className="box-icon w_28 round social-instagram bg_line"
                  >
                    <i className="icon fs-12 icon-instagram"></i>
                  </Link>
                </li>
              ) : (
                ""
              )}
              {settings.snapchat ? (
                <li>
                  <Link
                    to={settings.snapchat}
                    target="_blank"
                    className="box-icon w_28 round social-snapchat bg_line"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-snapchat"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15.943 11.526c-.111-.303-.323-.465-.564-.599a1 1 0 0 0-.123-.064l-.219-.111c-.752-.399-1.339-.902-1.746-1.498a3.4 3.4 0 0 1-.3-.531c-.034-.1-.032-.156-.008-.207a.3.3 0 0 1 .097-.1c.129-.086.262-.173.352-.231.162-.104.289-.187.371-.245.309-.216.525-.446.66-.702a1.4 1.4 0 0 0 .069-1.16c-.205-.538-.713-.872-1.329-.872a1.8 1.8 0 0 0-.487.065c.006-.368-.002-.757-.035-1.139-.116-1.344-.587-2.048-1.077-2.61a4.3 4.3 0 0 0-1.095-.881C9.764.216 8.92 0 7.999 0s-1.76.216-2.505.641c-.412.232-.782.53-1.097.883-.49.562-.96 1.267-1.077 2.61-.033.382-.04.772-.036 1.138a1.8 1.8 0 0 0-.487-.065c-.615 0-1.124.335-1.328.873a1.4 1.4 0 0 0 .067 1.161c.136.256.352.486.66.701.082.058.21.14.371.246l.339.221a.4.4 0 0 1 .109.11c.026.053.027.11-.012.217a3.4 3.4 0 0 1-.295.52c-.398.583-.968 1.077-1.696 1.472-.385.204-.786.34-.955.8-.128.348-.044.743.28 1.075q.18.189.409.31a4.4 4.4 0 0 0 1 .4.7.7 0 0 1 .202.09c.118.104.102.26.259.488q.12.178.296.3c.33.229.701.243 1.095.258.355.014.758.03 1.217.18.19.064.389.186.618.328.55.338 1.305.802 2.566.802 1.262 0 2.02-.466 2.576-.806.227-.14.424-.26.609-.321.46-.152.863-.168 1.218-.181.393-.015.764-.03 1.095-.258a1.14 1.14 0 0 0 .336-.368c.114-.192.11-.327.217-.42a.6.6 0 0 1 .19-.087 4.5 4.5 0 0 0 1.014-.404c.16-.087.306-.2.429-.336l.004-.005c.304-.325.38-.709.256-1.047m-1.121.602c-.684.378-1.139.337-1.493.565-.3.193-.122.61-.34.76-.269.186-1.061-.012-2.085.326-.845.279-1.384 1.082-2.903 1.082s-2.045-.801-2.904-1.084c-1.022-.338-1.816-.14-2.084-.325-.218-.15-.041-.568-.341-.761-.354-.228-.809-.187-1.492-.563-.436-.24-.189-.39-.044-.46 2.478-1.199 2.873-3.05 2.89-3.188.022-.166.045-.297-.138-.466-.177-.164-.962-.65-1.18-.802-.36-.252-.52-.503-.402-.812.082-.214.281-.295.49-.295a1 1 0 0 1 .197.022c.396.086.78.285 1.002.338q.04.01.082.011c.118 0 .16-.06.152-.195-.026-.433-.087-1.277-.019-2.066.094-1.084.444-1.622.859-2.097.2-.229 1.137-1.22 2.93-1.22 1.792 0 2.732.987 2.931 1.215.416.475.766 1.013.859 2.098.068.788.009 1.632-.019 2.065-.01.142.034.195.152.195a.4.4 0 0 0 .082-.01c.222-.054.607-.253 1.002-.338a1 1 0 0 1 .197-.023c.21 0 .409.082.49.295.117.309-.04.56-.401.812-.218.152-1.003.638-1.18.802-.184.169-.16.3-.139.466.018.14.413 1.991 2.89 3.189.147.073.394.222-.041.464" />
                    </svg>
                  </Link>
                </li>
              ) : (
                ""
              )}
              {settings.whatsapp_link ? (
                <li>
                  <Link
                    to={settings.whatsapp_link}
                    target="_blank"
                    className="box-icon w_28 round social-whatsapp bg_line"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-whatsapp"
                      viewBox="0 0 16 16"
                    >
                      <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                    </svg>
                  </Link>
                </li>
              ) : (
                ""
              )}
            </ul>
            <div className="text-center overflow-hidden">
              <div
                className="swiper tf-sw-top_bar"
                data-preview="1"
                data-space="0"
                data-loop="true"
                data-speed="1000"
                data-delay="2000"
              >
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <p className="top-bar-text fw-5">
                      {lang === "ar"
                        ? settings.offer_text_ar
                        : settings.offer_text}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {isDesktop ? (
              <>
                <div className="top-bar-lang tf-cur justify-content-end">
                  <div className="tf-currencies">
                    <div className="dropdown" ref={dropdownRef}>
                      <button
                        className="btn w-100 d-flex justify-content-between align-items-center"
                        type="button"
                        onClick={toggleDropdown}
                      >
                        <div className="d-flex align-items-center">
                          <img
                            src={currency.image}
                            alt=""
                            width={20}
                            height={20}
                            className="me-2"
                          />
                          {currency.currency}
                        </div>
                        <span className="ms-2">&#x25BC;</span>
                      </button>
                      <div
                        className={`dropdown-menu w-100${
                          isOpen ? " show" : ""
                        }`}
                      >
                        {currencies.map((c) => (
                          <button
                            key={c.currency}
                            className="dropdown-item"
                            onClick={() => setCurrency(c)}
                            value={c.id}
                          >
                            <img
                              src={c.image}
                              alt=""
                              width={20}
                              height={20}
                              className="me-2"
                            />
                            {c.currency}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="tf-langs">
                    <a
                      onClick={() => {
                        setLanguage(lang === "en" ? "ar" : "en");
                      }}
                      style={{ paddingTop: "7px" }}
                    >
                      {lang === "en" ? "عربى" : "English"}
                    </a>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <header id="header" className="header-default">
        <div className="container-full px_15 lg-px_40">
          <div className="row wrapper-header align-items-center">
            <div className="col-xl-2 col-md-4 col-4">
              {settings.image ? (
                <Link to="/" className="logo-header">
                  <img className="logo" src={settings.image} alt="logo" />
                </Link>
              ) : (
                ""
              )}
            </div>
            <div className="col-xl-8 tf-md-hidden">
              <nav className="box-navigation text-center">
                <ul className="box-nav-ul d-flex align-items-center justify-content-center gap-30">
                  {categories.map((list, index) => {
                    return (
                      <li className="menu-item" key={index}>
                        <Link
                          to={`/products/${list.slug}`}
                          className="item-link"
                        >
                          {lang === "ar" ? list.title_ar : list.title}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </nav>
            </div>
            <div className="col-xl-2 col-md-4 col-3 tf-md-hidden">
              <ul className="nav-icon d-flex justify-content-end align-items-center gap-20">
                <SearchPop></SearchPop>
                <li className="nav-account">
                  {user.isLoggedIn ? (
                    <Link to="/user/dashboard" className="nav-icon-item">
                      <i className="icon icon-account"></i>
                    </Link>
                  ) : (
                    <>
                      <button
                        data-bs-toggle="modal"
                        className="nav-icon-item"
                        onClick={openLogin}
                      >
                        <i className="icon icon-account"></i>
                      </button>
                      <Login isOpen={isLoginOpen} onClose={closeLogin}></Login>
                    </>
                  )}
                </li>
                <ShoppingPop></ShoppingPop>
              </ul>
            </div>
            <div className="col-xl-3 col-md-4 col-8 tf-lg-hidden top-bar-lang tf-cur justify-content-end currency-header-5">
              <div className="tf-currencies">
                <div className="dropdown" ref={dropdownRef}>
                  <button
                    className="btn w-100 d-flex justify-content-between align-items-center"
                    type="button"
                    onClick={toggleDropdown}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src={currency.image}
                        alt=""
                        width={20}
                        height={20}
                        className="me-2"
                      />
                      {currency.currency}
                    </div>
                    <span className="ms-2">&#x25BC;</span>
                  </button>
                  <div
                    className={`dropdown-menu w-100${isOpen ? " show" : ""}`}
                  >
                    {currencies.map((c) => (
                      <button
                        key={c.currency}
                        className="dropdown-item"
                        onClick={() => setCurrency(c)}
                      >
                        <img
                          src={c.image}
                          alt=""
                          width={20}
                          height={20}
                          className="me-2"
                        />
                        {c.currency}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              <div className="tf-langs">
                <a
                  onClick={() => {
                    setLanguage(lang === "en" ? "ar" : "en");
                  }}
                >
                  {lang === "en" ? "عربى" : "English"}
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
